module.exports = __webpack_public_path__ + "static/media/1259.4a8387e2.png";